import OwnRecipesSection from './OwnRecipesSection.jsx';
import OnboardingRecipesAdd from './OnboardingRecipesAdd.jsx';
import PackCardQuietStack from './PackCardQuietStack.jsx';
import './RecipePacks.css';

/**
 * MobileAddMature — Add tab for mobile.
 * Recipes you already have, then curated packs.
 */
export default function MobileAddMature({
  packs,
  addedPackIds,
  onOpenPack,
  onAddPack,
  urlImportValue,
  onUrlImportChange,
  onUrlImport,
  urlImportLoading,
  urlImportError,
  pasteImportValue,
  onPasteImportChange,
  onPasteImport,
  pasteImportLoading,
  pasteImportError,
  onPhotoImport,
  onConnectedAccount,
  headingLevel = 2,
  onboarding = false,
}) {
  const imports = (
    <OwnRecipesSection
      variant="mobile"
      headingLevel={onboarding ? 2 : headingLevel}
      onboarding={onboarding}
        urlImportValue={urlImportValue}
        onUrlImportChange={onUrlImportChange}
        onUrlImport={onUrlImport}
        urlImportLoading={urlImportLoading}
        urlImportError={urlImportError}
        pasteImportValue={pasteImportValue}
        onPasteImportChange={onPasteImportChange}
        onPasteImport={onPasteImport}
        pasteImportLoading={pasteImportLoading}
        pasteImportError={pasteImportError}
        onPhotoImport={onPhotoImport}
        onConnectedAccount={onConnectedAccount}
    />
  );

  if (onboarding) {
    return (
      <div className="rp-mobile-add-shell rp-mobile-add-shell--onboarding">
        <OnboardingRecipesAdd
          packs={packs}
          addedPackIds={addedPackIds}
          onOpenPack={onOpenPack}
          onAddPack={onAddPack}
        />
        {imports}
      </div>
    );
  }

  return (
    <div className="rp-mobile-add-shell">
      {imports}

      <h2 className="rp-mobile-add-heading rp-mobile-add-heading-tight rp-own-recipes-heading">
        Try some of our favorites.
      </h2>
      <p className="rp-mobile-pack-meta rp-own-recipes-meta">Each one is a group of curated recipes.</p>

      <div className="rp-mobile-pack-list">
        {packs.map(p => (
          <PackCardQuietStack
            key={p.id}
            pack={p}
            added={addedPackIds.has(p.id)}
            onOpen={() => onOpenPack(p.id)}
            onAdd={onAddPack}
          />
        ))}
      </div>
    </div>
  );
}
